module.exports = __webpack_public_path__ + "img/4.455474b8.png";